import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "selectedCountries";
const initialState = {
  selectedCountries: [],
  loading: false,
  error: null,
};

export const selectCountries = createAsyncThunk(
  "countries/selectCountries",
  async (countries) => {
    return countries;
  }
);

const selectedCountriesSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(selectCountries.fulfilled, (state, action) => {
      state.selectedCountries = action.payload;
      state.loading = false;
      state.error = null;
    });
  },
});

export default selectedCountriesSlice.reducer;
